import { Action, Module, VuexModule } from "vuex-module-decorators";
import { Feedbacks } from "@/store/enums/StoreEnums";
import ApiService from "@/core/services/ApiService";
import { CookieComponent } from "@/assets/ts/components";

@Module
export default class FeedbacksModule extends VuexModule {
    @Action
    [Feedbacks.getAllFeedbackByFilter](values) {
        return new Promise<void>((resolve, reject) => {
            ApiService.post(`/api/v1/feedbacks/search`, values)
                .then(({ data }) => {
                    resolve(data);
                })
                .catch(({ response }) => {
                    reject(response);
                });
        });
    }

    @Action
    [Feedbacks.getFeedbackById](values) {
        return new Promise<void>((resolve, reject) => {
            ApiService.get(`/api/v1`, `feedbacks/${values}`)
                .then(({ data }) => {
                    resolve(data);
                })
                .catch(({ response }) => {
                    reject(response);
                });
        });
    }

    @Action
    [Feedbacks.insertFeedback](values) {
        return new Promise<void>((resolve, reject) => {
            ApiService.post(`/api/v1/feedbacks/`, values)
                .then(({ data }) => {
                    resolve(data);
                })
                .catch(({ response }) => {
                    reject(response);
                });
        });
    }

    @Action
    [Feedbacks.updateFeedbackById](values) {
        return new Promise<void>((resolve, reject) => {
            ApiService.put(`/api/v1/feedbacks/update/${values.nMaPhanAnh}`, values)
                .then(({ data }) => {
                    resolve(data);
                })
                .catch(({ response }) => {
                    reject(response);
                });
        });
    }

    @Action
    [Feedbacks.deleteFeedbackById](values) {
        return new Promise<void>((resolve, reject) => {
            ApiService.delete(`/api/v1/feedbacks/delete/${values}`)
                .then(({ data }) => {
                    resolve(data);
                })
                .catch(({ response }) => {
                    reject(response);
                });
        });
    }

    @Action
    [Feedbacks.getAllResponseByFeedbackId](values) {
        return new Promise<void>((resolve, reject) => {
            ApiService.get(`/api/v1`, `feedbacks/${values.feedbackId}/responses`)
                .then(({ data }) => {
                    resolve(data);
                })
                .catch(({ response }) => {
                    reject(response);
                });
        });
    }

    @Action
    [Feedbacks.insertResponsesByFeedbackId](values, onUploadProgress) {
        return new Promise<void>((resolve, reject) => {
            ApiService.post(`/api/v1/feedbacks/${values.nMaPhanAnh}/responses`, values.formData, { headers: { 'Content-Type': 'multipart/form-data' }, onUploadProgress: onUploadProgress })
                .then(({ data }) => {
                    resolve(data);
                })
                .catch(({ response }) => {
                    reject(response);
                });
        });
    }

    @Action
    [Feedbacks.updateResponseByFeedbackId](values, onUploadProgress) {
        return new Promise<void>((resolve, reject) => {
            ApiService.post(`/api/v1/feedbacks/${values.nMaPhanAnh}/responses/${values.nMaPhanHoi}`, values.formData, { headers: { 'Content-Type': 'multipart/form-data' }, onUploadProgress: onUploadProgress })
                .then(({ data }) => {
                    resolve(data);
                })
                .catch(({ response }) => {
                    reject(response);
                });
        });
    }

    @Action
    [Feedbacks.deleteResponseByFeedbackId](values) {
        return new Promise<void>((resolve, reject) => {
            ApiService.delete(`/api/v1/feedbacks/${values.feedbackId}/responses/${values.responseId}`)
                .then(({ data }) => {
                    resolve(data);
                })
                .catch(({ response }) => {
                    reject(response);
                });
        });
    }

    @Action
    [Feedbacks.getResponseById](values) {
        return new Promise<void>((resolve, reject) => {
            ApiService.get(`/api/v1`, `feedbacks/${values.feedbackId}/responses/${values.responseId}`)
                .then(({ data }) => {
                    resolve(data);
                })
                .catch(({ response }) => {
                    reject(response);
                });
        });
    }

    @Action
    [Feedbacks.listFeedBack](values) {
        return new Promise<void>((resolve, reject) => {
            ApiService.post(`/api/v1/feedbacks/list`, values)
                .then(({ data }) => {
                    resolve(data);
                })
                .catch(({ response }) => {
                    reject(response);
                });
        });
    }

    @Action
    [Feedbacks.feedbackHistory](values) {
        return new Promise<void>((resolve, reject) => {
            ApiService.post(`/api/v1/feedbacks/history`, values)
                .then(({ data }) => {
                    resolve(data);
                })
                .catch(({ response }) => {
                    reject(response);
                });
        });
    }


    @Action
    [Feedbacks.getFeedBackType]() {
        return new Promise<void>((resolve, reject) => {
            ApiService.post(`/api/v1/feedbacks/type`, {})
                .then(({ data }) => {
                    resolve(data);
                })
                .catch(({ response }) => {
                    reject(response);
                });
        });
    }
}